/**
 * Represents the reasons for a custom date of service for a customer.
 */
export enum CustomerCustomDateOfServiceReasonModel {
	/**
	 * Custom date of service, manually defined by the user.
	 */
	Custom = 1,
	/**
	 * Lookback date of service, used to refer to past data or claims.
	 */
	Lookback = 2,
	/**
	 * Catchup date of service, used to reconcile or update missing data.
	 */
	Catchup = 3
}
